interface AuthUser {
  organization_role?: string
  super_admin?: boolean
  access_all_projects?: boolean
}

export function isAdmin(user: AuthUser | null | undefined): boolean {
  if (!user) return false
  return user.organization_role === 'admin' || user.super_admin === true
}

export function isExternal(user: AuthUser | null | undefined): boolean {
  if (!user) return false
  return user.organization_role === 'external'
}

export function hasAllProjectAccess(user: AuthUser | null | undefined): boolean {
  if (!user) return false
  return isExternal(user) && user.access_all_projects === true
}
